<template>
  <transition name="fade">
    <div v-if="isLoading" class="loading-screen">
      <div class="loader">
        <div class="vinyl-record">
          <div class="vinyl-center"></div>
        </div>
        <p class="loading-text">Playlist Transfer</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingScreen',
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 1500)
  }
}
</script>

<style scoped>
.loading-screen {
  position: fixed;
  inset: 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loader {
  text-align: center;
}

.vinyl-record {
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, #1a1a1a 30%, #2d2d2d 31%, #1a1a1a 32%, #000 100%);
  border-radius: 50%;
  position: relative;
  animation: spin 2s linear infinite;
  box-shadow: 0 0 40px rgba(61, 173, 254, 0.4);
}

.vinyl-center {
  position: absolute;
  width: 35px;
  height: 35px;
  background: linear-gradient(135deg, #3DADFE 0%, #2b8fd9 100%);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 20px rgba(61, 173, 254, 0.6);
}

.vinyl-center::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  background: #0f1419;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loading-text {
  margin-top: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  background: linear-gradient(135deg, #3DADFE 0%, #2b8fd9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
